import { createSlice } from "@reduxjs/toolkit";
import merchantApi from "../api/merchant";
import { AdvertModel } from "../types";

const slice = createSlice({
  name: "advert",
  initialState: {
    advertList: [],
  } as AdvertState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      merchantApi.endpoints.getAdverts.matchFulfilled,
      (state, { payload }) => {
        return {
          ...state,
          advertList: payload,
        };
      }
    );
    builder.addMatcher(
      merchantApi.endpoints.addEditAdvert.matchFulfilled,
      (state, { payload }) => {
        let advertList = state.advertList.slice();
        const index = advertList.findIndex(
          (c) => c.postId == payload[0].postId
        );
        if (index > -1) {
          advertList[index] = payload[0];
        } else {
          advertList.splice(0, 0, ...payload);
        }
        return {
          ...state,
          advertList,
        };
      }
    );
    builder.addMatcher(
      merchantApi.endpoints.deleteAdvert.matchFulfilled,
      (state, { payload }) => {
        return {
          ...state,
          advertList: state.advertList.filter((c) => c.postId != payload),
        };
      }
    );
    builder.addMatcher(
      merchantApi.endpoints.updateAdvertStatus.matchFulfilled,
      (state, { payload }) => {
        let advertList = state.advertList.slice();
        const index = advertList.findIndex(
          (c) => c.postId == payload[0].postId
        );
        if (index > -1) {
          advertList[index] = {
            ...advertList[index],
            postStatus: payload[0].postStatus,
          };
        }
        return {
          ...state,
          advertList,
        };
      }
    );
  },
});

export const advert = slice.reducer;

export interface AdvertState {
  advertList: AdvertModel[];
}
